import React from 'react';
import { ShieldAlert, Users, FileText, AlertTriangle, Flag, MessageSquare, Gavel } from 'lucide-react';
import { DashboardLayout } from '../../components/DashboardLayout';
export function DisputesPage() {
  const navItems = [{
    label: 'Verification Queue',
    icon: FileText,
    path: '/admin',
    badge: '12'
  }, {
    label: 'User Management',
    icon: Users,
    path: '/admin/users'
  }, {
    label: 'Disputes',
    icon: Flag,
    path: '/admin/disputes'
  }, {
    label: 'Risk Analysis',
    icon: AlertTriangle,
    path: '/admin/risk'
  }];
  return <DashboardLayout title="Admin Console" personaLabel="ADMIN" personaColor="bg-red-100 text-red-800 border-red-200" navItems={navItems} userInitials="AD" data-id="element-1372">
      <h1 className="text-2xl font-bold mb-8" data-id="element-1373">Dispute Resolution</h1>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-1374">
        <div className="lg:col-span-2 space-y-4" data-id="element-1375">
          {[{
          id: 'DSP-8821',
          title: 'Token amount not refunded',
          parties: 'Buyer: John D. vs Seller: Amit S.',
          status: 'Open',
          priority: 'High',
          date: '2 days ago'
        }, {
          id: 'DSP-8819',
          title: 'Misrepresentation of plot area',
          parties: 'Buyer: Sarah J. vs Dev: Sunrise',
          status: 'In Review',
          priority: 'Medium',
          date: '5 days ago'
        }, {
          id: 'DSP-8804',
          title: 'Document authenticity query',
          parties: 'Buyer: Rahul K. vs Seller: Unknown',
          status: 'Resolved',
          priority: 'Low',
          date: '1 week ago'
        }].map((dispute, i) => <div key={i} className="bg-white border border-gray-300 p-6 hover:shadow-sm" data-id="element-1376">
              <div className="flex justify-between items-start mb-2" data-id="element-1377">
                <div className="flex items-center gap-2" data-id="element-1378">
                  <span className="font-mono text-xs font-bold text-gray-500" data-id="element-1379">
                    {dispute.id}
                  </span>
                  <span className={`px-2 py-0.5 text-[10px] font-bold uppercase rounded ${dispute.priority === 'High' ? 'bg-red-100 text-red-800' : dispute.priority === 'Medium' ? 'bg-yellow-100 text-yellow-800' : 'bg-green-100 text-green-800'}`} data-id="element-1380">
                    {dispute.priority} Priority
                  </span>
                </div>
                <span className="text-xs text-gray-400" data-id="element-1381">{dispute.date}</span>
              </div>
              <h3 className="font-bold text-lg mb-1" data-id="element-1382">{dispute.title}</h3>
              <p className="text-sm text-gray-600 mb-4" data-id="element-1383">{dispute.parties}</p>

              <div className="flex gap-3 pt-4 border-t border-gray-100" data-id="element-1384">
                <button className="flex items-center gap-2 text-sm font-bold text-[#1f2933]" data-id="element-1385">
                  <MessageSquare className="w-4 h-4" data-id="element-1386" /> View Thread
                </button>
                <button className="flex items-center gap-2 text-sm font-bold text-[#1f2933]" data-id="element-1387">
                  <Gavel className="w-4 h-4" data-id="element-1388" /> Take Action
                </button>
                <span className="ml-auto text-sm font-bold text-blue-600" data-id="element-1389">
                  {dispute.status}
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-white border border-gray-300 p-6 h-fit" data-id="element-1390">
          <h2 className="font-bold text-lg mb-4" data-id="element-1391">Dispute Stats</h2>
          <div className="space-y-4" data-id="element-1392">
            <div className="flex justify-between items-center" data-id="element-1393">
              <span className="text-sm text-gray-600" data-id="element-1394">Open Cases</span>
              <span className="font-bold text-xl" data-id="element-1395">5</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-1396">
              <span className="text-sm text-gray-600" data-id="element-1397">Avg Resolution</span>
              <span className="font-bold text-xl" data-id="element-1398">3 Days</span>
            </div>
            <div className="flex justify-between items-center" data-id="element-1399">
              <span className="text-sm text-gray-600" data-id="element-1400">Escalated</span>
              <span className="font-bold text-xl text-red-600" data-id="element-1401">1</span>
            </div>
          </div>
          <div className="mt-6 pt-6 border-t border-gray-200" data-id="element-1402">
            <button className="w-full py-2 bg-red-600 text-white text-sm font-bold hover:bg-red-700" data-id="element-1403">
              Download Legal Report
            </button>
          </div>
        </div>
      </div>
    </DashboardLayout>;
}